import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ActionFunctionArgs, redirect, useLoaderData, useNavigate, useSubmit } from 'react-router-dom';
import styled from 'styled-components';
import { fetchClassById, updateClassById } from '../api';
import { Field, Formik, Form as FormikForm } from 'formik';
import { object, string } from 'yup';
import { useMemo } from 'react';
import { get, startCase } from 'lodash';
import { Class } from './classes';


const StyledOption = styled.option``;
const StyledButton = styled(Button)`
  background-color: #3498db;
  border-color: #3498db;
  color: #fff;
`;

export async function editClassLoader({ params }: any) {
  const _class = await fetchClassById(get(params, 'classId'));
  return { _class };
}

export async function editClassAction({ request }: ActionFunctionArgs) {
  const { classId, values } = await request.json();
  await updateClassById(classId, values);

  return redirect('/classes');
}

let grades = Array.from({ length: 12 }, (value, index) => (index + 1));

const mappedGradeOptions = grades.map((grade, index) => {
  const option = ({ value: grade, label: startCase(String(grade)) });
  return (<StyledOption key={index} value={option.value}>{option.label}</StyledOption>);
});

const initialValues = {
  grade: '',
  class: '',
};

const validationSchema = object({
  grade: string().required('Grade is required'),
  class: string().required('Class is required'),
});

function EditClass() {
  const { _class } = useLoaderData() as { _class: Class };
  const navigate = useNavigate();
  const submit = useSubmit();

  const _initialValues = useMemo(() => ({
    ...initialValues,
    grade: get(_class, 'grade'),
    class: get(_class, 'class'),
  }), [_class]);

  const handleClose = () => navigate('/classes');

  const handleSubmit = (values: any) => {
    submit({ values, classId: _class.id }, { method: "put", encType: 'application/json' });
  };

  return (
    <Modal
      show={true}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Formik initialValues={_initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ touched, errors }) => (
          <Form as={FormikForm} noValidate>
            <Modal.Header closeButton>
              <Modal.Title>Edit Class</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group as={Row} className="mb-3" controlId="grade">
                <Form.Label column sm="4">
                  Grade:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Select}
                    name='grade'
                    isInvalid={touched.grade && !!errors.grade}
                  >
                    <StyledOption></StyledOption>
                    {mappedGradeOptions}
                  </Field>
                  <Form.Control.Feedback type='invalid'>{errors.grade}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="class">
                <Form.Label column sm="4">
                  Class:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Control}
                    type='text'
                    name='class'
                    isInvalid={touched.class && !!errors.class}
                  />
                  <Form.Control.Feedback type='invalid'>{errors.class}</Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Close
              </Button>
              <StyledButton type='submit'>Submit</StyledButton>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default EditClass;
